import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=4304815b&scoped=true&"
import script from "./fail.vue?vue&type=script&lang=js&"
export * from "./fail.vue?vue&type=script&lang=js&"
import style0 from "./fail.vue?vue&type=style&index=0&id=4304815b&prod&lang=scss&scoped=true&"
import style1 from "./fail.vue?vue&type=style&index=1&id=4304815b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4304815b",
  null
  
)

export default component.exports